export default {"src":"/_next/static/media/logo-color-black.5cfde5f6.svg","height":254,"width":1646};